export enum ResponsiveSizes {
  CHECKOUT_DESKTOP = 768,
}
